import React from 'react';
import { Container, Grid, Box, Typography, Card, CardContent } from '@mui/material';
import { School, EmojiEvents, Groups, TrendingUp } from '@mui/icons-material';

export const AboutSection: React.FC = () => {
    const highlights = [
        {
            icon: School,
            title: 'Expert Tutors',
            description: 'Experienced educators passionate about 11+ success',
        },
        {
            icon: EmojiEvents,
            title: 'Proven Results',
            description: 'Track record of students achieving grammar school places',
        },
        {
            icon: Groups,
            title: 'Small Classes',
            description: 'Maximum 1-2 students per group for personalized attention',
        },
        {
            icon: TrendingUp,
            title: 'Progress Tracking',
            description: 'Regular assessments and detailed feedback reports',
        },
    ];

    return (
        <Box
            id="about"
            sx={{
                py: { xs: 8, md: 12 },
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h2"
                    sx={{
                        mb: 4,
                        textAlign: 'center',
                        background: 'linear-gradient(135deg, #5b4cdb 0%, #1e293b 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}
                >
                    About Myl 
                </Typography>

                <Box sx={{ maxWidth: 800, mx: 'auto', textAlign: 'center', mb: 6 }}>
                    <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary', lineHeight: 1.8 }}>
                        <strong>Myl </strong> is a dedicated <strong>11+ coaching centre</strong>{' '}
                        committed to excellence in education. We understand that every child is unique. Our
                        teaching approach focuses on clear explanations, regular practice, and
                        confidence-building — so students feel ready for exam day.
                    </Typography>

                    <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                        Our goal is not just exam success, but helping children become{' '}
                        <strong>independent, confident learners</strong>.
                    </Typography>
                </Box>

                {/* New Highlights Section */}
                <Grid container spacing={3} sx={{ mt: 4 }}>
                    {highlights.map((item, index) => {
                        const Icon = item.icon;
                        return (
                            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                                <Card
                                    sx={{
                                        height: '100%',
                                        textAlign: 'center',
                                        transition: 'all 0.3s ease',
                                    }}
                                >
                                    <CardContent sx={{ p: 3 }}>
                                        <Box
                                            sx={{
                                                width: 64,
                                                height: 64,
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #5b4cdb 0%, #06b6d4 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mx: 'auto',
                                                mb: 2,
                                            }}
                                        >
                                            <Icon sx={{ color: '#fff', fontSize: 32 }} />
                                        </Box>
                                        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                                            {item.title}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                                            {item.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};
